'use client';

import { Button } from '@mui/material';
import { IOrderStatusInclAll } from 'my-poppies-b2b-types';
import { useContext } from 'react';

import { Container } from '@/components/Container';
import { StatusIcon } from '@/components/StatusIcon';
import { DataContext } from '@/contexts/DataContext';
import { useAppPush } from '@/hooks/useAppPush';
import useTranslation from '@/hooks/useTranslation';

interface IOrderStatusCategoryRowProps {
  status: IOrderStatusInclAll;
}

export const OrderStatusCategoryRow = ({ status }: IOrderStatusCategoryRowProps) => {
  const t = useTranslation();
  const { push } = useAppPush();
  const { orderCountPerStatus } = useContext(DataContext);

  const nrOfOrdersWithStatus = orderCountPerStatus?.[status] ?? 0;

  if (nrOfOrdersWithStatus === 0 && status !== 'ALL_ORDERS' && status !== 'ALL_OPEN_ORDERS') {
    return null;
  }

  return (
    <Container
      debugColor={'gold'}
      sx={{ padding: '4px 16px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}
    >
      <Container
        debugColor={'gray'}
        sx={{
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          flexGrow: 0,
          width: 'unset',
          margin: 'unset',
          marginRight: 8,
        }}
      >
        <StatusIcon status={status} statusType={'STATUS'} />
      </Container>
      <Container
        debugColor={'gray'}
        sx={{
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          flexGrow: 1,
        }}
      >
        {t(`order.status.${status}`)}: {nrOfOrdersWithStatus}
      </Container>
      <Container debugColor={'blue'} sx={{ flexGrow: 0, flexBasis: 200, display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          disabled={nrOfOrdersWithStatus === 0}
          onClick={() => {
            push(`/orders?status=${status}`);
          }}
          sx={{ fontSize: `min(16px, 3dvw)` }}
        >
          {t('general.open')}
        </Button>
      </Container>
    </Container>
  );
};
